import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { TTP_EMAILING_URL } from 'Config';
import { closeGenericEmailingViewer } from 'actions';
import Content from '../Content';

const customStyles = {
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    overflow: 'none',
    padding: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};

class GenericEmailingViewer extends PureComponent {
  handleAfterOpenModal() {}

  handleCloseModal = () => {
    const { onCloseCallback } = this.props.viewer;

    if (onCloseCallback) {
      onCloseCallback();
    }

    this.props.closeGenericEmailingViewer();
  }

  getUrl() {
    const { viewer, fromName, fromEmail } = this.props;
    let url = `${TTP_EMAILING_URL}/generic-email`;
    const params = [];
    if (viewer.id) {
      url = `${url}/${viewer.id}`;
      params.push({
        key: 'id',
        value: viewer.id
      });
    }
    if (viewer.targetId) {
      params.push({
        key: 'targetId',
        value: viewer.targetId
      });
    }
    if (viewer.communityId) {
      params.push({
        key: 'communityId',
        value: viewer.communityId
      });
    }
    params.push({
      key: 'targetApp',
      value: 'SURVEY'
    });
    if (viewer.targetTitle) {
      params.push({
        key: 'targetTitle',
        value: viewer.targetTitle
      });
    }
    if (viewer.targetType) {
      params.push({
        key: 'targetType',
        value: viewer.targetType
      });
    }
    if (viewer.language) {
      params.push({
        key: 'language',
        value: viewer.language
      });
    }
    if (!viewer.id && fromEmail) {
      params.push({
        key: 'fromEmail',
        value: fromEmail
      },
      {
        key: 'fromName',
        value: fromName
      });
    }
    if (params.length != 0) {
      url = `${url}?`;
      let param;
      // eslint-disable-next-line no-cond-assign
      while (param = params.pop()) {
        url = `${url}${param.key}=${param.value}`;
        if (params.length != 0) {
          url = `${url}&`;
        }
      }
    }

    return url;
  }

  render() {
    const { viewer } = this.props;
    const url = this.getUrl();

    if (!viewer.isOpen) {
      return false;
    }
    return (
      <Modal
        isOpen={viewer.isOpen}
        onAfterOpen={this.handleAfterOpenModal}
        onRequestClose={this.handleCloseModal.bind(this)}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
        contentLabel="Generic Emailing Viewer"
      >
        <div className="rmodal reveal-viewer" id="emailingViewer">
          {/* <CloseViewer closeViewer={this.handleCloseModal} /> */}
          <Content url={url} title="Emailing generic" />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  viewer: state.emailingViewer.genericEmailing,
});

const mapDispatchToProps = { closeGenericEmailingViewer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenericEmailingViewer);
